/* eslint-disable @typescript-eslint/no-this-alias */
import { MixedSchema, ObjectSchema, mixed, object, addMethod, ValidationError } from "yup"
import { TestMinOrMax, TestMoneyInput, TestNumericBound } from "~/types/yup/types"

export function testNumber(this: MixedSchema, message?: string) {
  return this.test("validateNumber", message || "Must be a number", function (_value) {
    const value = typeof _value === "object" ? _value.amount : _value
    return !value || !!Number(value) || Number(value) === 0
  })
}

export function testPositive(this: MixedSchema, message?: string) {
  return this.test("validatePositiveNumber", message || "Must be positive", function (value) {
    return !value || Number(value) >= 0
  })
}

export function testMin(this: MixedSchema, props: TestMinOrMax) {
  let base = this
  const { value, message } = props
  if (!value) return base

  base = base.test(
    "notLessThan",
    message || `Cannot be less than ${value}`,
    function (testPayloadValue) {
      return value ? value <= Number(testPayloadValue) : true
    },
  )
  return base
}

export function testMax(this: MixedSchema, props: TestMinOrMax) {
  let base = this
  const { value, message } = props
  if (!value) return base

  base = base.test(
    "notGreaterThan",
    message || `Cannot be greater than ${value}`,
    function (testPayloadValue) {
      return value ? value >= Number(testPayloadValue) : true
    },
  )
  return base
}

export function testNumericBounds(this: MixedSchema, props: TestNumericBound) {
  let base = this
  const { min, minMessage, max, maxMessage } = props
  if (min) {
    base = base.testMin({
      value: min,
      message: minMessage,
    })
  }
  if (max) {
    base = base.testMax({
      value: max,
      message: maxMessage,
    })
  }
  return base
}

export function testPercentageBounds(this: MixedSchema, props: TestNumericBound) {
  if (props?.max && props.max > 100)
    throw new ValidationError("Maximum cannot exceed 100", props.max, "path")
  return this.testNumericBounds(props).testMax({ value: 100, message: "Cannot exceed 100" })
}

export function testMoneyInput(this: ObjectSchema, props: TestMoneyInput) {
  return this.shape(
    {
      currency: props.testCurrency || mixed(),
      amount: props.testAmount || mixed(),
    },
    [["currency", "amount"]],
  ).test(
    "shouldHaveCurrencyAndAmount",
    props.message || "You must enter both currency and amount",
    function (value) {
      return !!value?.currency && !!value?.amount
    },
  )
}

/** mixed section */
addMethod(mixed, "testMin", testMin)
addMethod(mixed, "testMax", testMax)
addMethod(mixed, "testNumber", testNumber)
addMethod(mixed, "testPositive", testPositive)
addMethod(mixed, "testNumericBounds", testNumericBounds)
addMethod(mixed, "testPercentageBounds", testPercentageBounds)

/** object section */
addMethod(object, "testMoneyInput", testMoneyInput)
